import { render } from "./Template.vue?vue&type=template&id=f5278bda&scoped=true"
import script from "./Template.vue?vue&type=script&lang=js"
export * from "./Template.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-f5278bda"

export default script